document.addEventListener("DOMContentLoaded", function () {
   let sortController = null;

  async function applyCollectionSort(sortValue) {
    const currentUrl = new URL(window.location.href);

    // Update query params
    currentUrl.searchParams.set('sort_by', sortValue);
    currentUrl.searchParams.delete('page'); // Reset pagination

    const productsContainer = document.querySelector('#product_content');
    if (!productsContainer) {
      window.location.href = currentUrl.toString();
      return;
    }

    // Abort previous request if still running
    if (sortController) {
      sortController.abort();
    }

    sortController = new AbortController();

    try {
      productsContainer.classList.add('loading'); // Optional loader class

      const response = await fetch(currentUrl.toString(), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: sortController.signal
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('#product_content');

      if (!newProducts) {
        window.location.href = currentUrl.toString();
        return;
      }

      // Replace content safely
      productsContainer.innerHTML = newProducts.innerHTML;

      // Update URL (without reload)
      window.history.pushState(
        { sort_by: sortValue },
        '',
        currentUrl.toString()
      );

    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Sort failed:', error);
        window.location.href = currentUrl.toString();
      }
    } finally {
      productsContainer.classList.remove('loading');
    }
  }

  // Listen for sort change
  document.addEventListener('change', function (event) {
    if (event.target?.id === 'SortBy') {
      applyCollectionSort(event.target.value);
    }
  });

  // Handle browser back/forward
  window.addEventListener('popstate', async () => {
    try {
      const response = await fetch(window.location.href);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newProducts = doc.querySelector('#product_content');
      const productsContainer = document.querySelector('#product_content');

      if (newProducts && productsContainer) {
        productsContainer.innerHTML = newProducts.innerHTML;
      } else {
        window.location.reload();
      }
    } catch {
      window.location.reload();
    }
  });
  
});
